import React from "react";
import PropTypes from "prop-types";
import getStyled from "../../hooks/getStyled";

const { styled } = getStyled();

const StyledBullets = styled("div", { shouldForwardProp: false })(
  ({ theme, bulletCount, alignCenter = true }) => ({
    "& .bullet-container": {
      display: "flex",
      alignItems: "center",
      position: "relative",
      // If it's not only one bullet
      ...(bulletCount !== 1 && {
        //first bulet
        "&:first-of-type": {
          "&:after": {
            content: "''",
            position: "absolute",
            left: 15,
            borderLeft: `2px solid ${theme.palette.grey250.main}`,
            height: "calc(50% - 15px)",
            width: 0,
            top: "calc(50% + 15px)",
          },
        },
        //last bullet
        "&:last-of-type:not(.half-circle-container)": {
          "&:before": {
            content: "''",
            position: "absolute",
            left: 15,
            borderLeft: `2px solid ${theme.palette.grey250.main}`,
            height: "calc(50% - 15px)",
            width: 0,
            bottom: "calc(50% + 15px)",
          },
        },
        //bullet between others
        "&:not(:first-of-type):not(:last-of-type):not(.half-circle-container)":
          {
            "&:before": {
              content: "''",
              position: "absolute",
              left: 15,
              borderLeft: `2px solid ${theme.palette.grey250.main}`,
              height: "calc(50% - 15px)",
              width: 0,
              bottom: "calc(50% + 15px)",
            },
            "&:after": {
              content: "''",
              position: "absolute",
              left: 15,
              borderLeft: `2px solid ${theme.palette.grey250.main}`,
              height: "calc(50% - 15px)",
              width: 0,
              top: "calc(50% + 15px)",
            },
          },
        "&.half-circle-container": {
          //last bullet
          "&:last-of-type": {
            "&:before": {
              content: "''",
              position: "absolute",
              left: 15,
              borderLeft: `2px solid ${theme.palette.grey250.main}`,
              height: "calc(50% - 36px)",
              width: 0,
              bottom: "calc(50% + 36px)",
            },
          },
          //bullet between others
          "&:not(:first-of-type):not(:last-of-type)": {
            "&:before": {
              content: "''",
              position: "absolute",
              left: 15,
              borderLeft: `2px solid ${theme.palette.grey250.main}`,
              height: "calc(50% - 35px)",
              width: 0,
              bottom: "calc(50% + 35.5px)",
            },
            "&:after": {
              content: "''",
              position: "absolute",
              left: 15,
              borderLeft: `2px solid ${theme.palette.grey250.main}`,
              height: "calc(50% - 36px)",
              width: 0,
              top: "calc(50% + 35.5px)",
            },
          },
        },
      }),
    },
    "& .bullet": {
      minWidth: 30,
      width: 30,
      height: 30,
      borderRadius: "50%",
      padding: 5,
      color: theme.palette.grey500.main,
      fontWeight: 700,
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&.primary": {
        backgroundColor: theme.palette.yellow400.main,
        border: `1px solid ${theme.palette.yellow400.main}`,
        position: "relative",
      },
      "&.secondary": {
        backgroundColor: theme.palette.white.main,
        border: `1px solid ${theme.palette.grey300.main}`,
        position: "relative",
      },
    },
    "& .half-circle": {
      width: 37.5,
      height: 75,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "transparent",
      borderBottomLeftRadius: 37.5,
      borderTopLeftRadius: 37.5,
      border: `2px solid ${theme.palette.grey250.main}`,
      borderRight: 0,
      position: "absolute",
      left: "-23px",
    },
    "& .bullet-content": {
      padding: 20,
      ...(!alignCenter && {
        height: 120,
        position: "relative",
        top: 26,
      }),
    },
  })
);

const alphabetArray = "abcdefghijklmnopqrstuvwxyz".split("");

const Bullet = ({ index, showHalfCircle }) => {
  if (index % 2 === 0) {
    return (
      <div className="bullet primary">
        {alphabetArray[index].toLocaleUpperCase()}
      </div>
    );
  }
  return (
    <div className="bullet secondary">
      {showHalfCircle && <div className="half-circle"></div>}
      {alphabetArray[index].toLocaleUpperCase()}
    </div>
  );
};

export const SFVerticalBullets = ({
  bullets = [],
  showHalfCircle,
  alignItems = "center",
}) => {
  return (
    <StyledBullets
      bulletsCount={bullets.length}
      alignCenter={alignItems === "center"}
    >
      {bullets.map((content, index) => (
        <div
          key={index}
          className={`bullet-container ${
            index % 2 !== 0 && showHalfCircle ? "half-circle-container" : ""
          }`}
        >
          <Bullet index={index} showHalfCircle={showHalfCircle} />
          <div className="bullet-content">{content}</div>
        </div>
      ))}
    </StyledBullets>
  );
};

SFVerticalBullets.propTypes = {
  alignItems: PropTypes.oneOf(["center", "baseline"]),
};
